/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_VersioningInputs */

const en_svchip_versioning = /** @type {(inputs: Svchip_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versioning`)
};

const ar_svchip_versioning = /** @type {(inputs: Svchip_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإصدار`)
};

const bn_svchip_versioning = /** @type {(inputs: Svchip_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভার্সনিং`)
};

const de_svchip_versioning = /** @type {(inputs: Svchip_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versionierung`)
};

const es_svchip_versioning = /** @type {(inputs: Svchip_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versiones`)
};

const fr_svchip_versioning = /** @type {(inputs: Svchip_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion des versions`)
};

const pt_svchip_versioning = /** @type {(inputs: Svchip_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versionamento`)
};

const zh_svchip_versioning = /** @type {(inputs: Svchip_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`版本控制`)
};

const tr_svchip_versioning = /** @type {(inputs: Svchip_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versioning`)
};

const ru_svchip_versioning = /** @type {(inputs: Svchip_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление версиями`)
};

const pl_svchip_versioning = /** @type {(inputs: Svchip_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wersjonowanie`)
};

/**
* | output |
* | --- |
* | "Versioning" |
*
* @param {Svchip_VersioningInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_versioning = /** @type {((inputs?: Svchip_VersioningInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_VersioningInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_versioning(inputs)
	if (locale === "bn") return bn_svchip_versioning(inputs)
	if (locale === "de") return de_svchip_versioning(inputs)
	if (locale === "es") return es_svchip_versioning(inputs)
	if (locale === "fr") return fr_svchip_versioning(inputs)
	if (locale === "pt") return pt_svchip_versioning(inputs)
	if (locale === "zh") return zh_svchip_versioning(inputs)
	if (locale === "tr") return tr_svchip_versioning(inputs)
	if (locale === "ru") return ru_svchip_versioning(inputs)
	if (locale === "pl") return pl_svchip_versioning(inputs)
	return en_svchip_versioning(inputs)
});